module.exports = __webpack_public_path__ + "static/img/dxyz.0553abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/dxyz.png
// module id = Q8F6
// module chunks = 1